import Highcharts from 'highcharts';
Highcharts.setOptions({
	lang: {
		      decimalPoint: ','
	      }

});

export const figure42 = {
chart: {
zoomType: 'xy',
animation: false,
marginTop: 50,
plotBackgroundColor: null,
plotBorderWidth: null,
plotShadow: false,
type: 'bar',
height: '2000px',
backgroundColor: 'rgba(255, 255, 255, 0.0)',
style: {
fontFamily: 'Montserrat'
}
},
credits: {
enabled: false
},
title: {
text: null
},
subtitle: {
text: null
},
plotOptions: {
series: {
borderWidth: 0,
stacking: 'normal',
}
},
exporting: {
enabled: false
},
xAxis: [{
tickWidth: 0,
labels: {
groupedOptions: [{
	  style: {
			 transform: 'unset'
		 },
  }],
  style: {
			 transform: 'translateX(11px)'
		 },
		 align: 'right'
},
categories: [
{
name: "El Caribe",
categories: ["Santa Lucía*", "San Vicente y las Granadinas*", "República Dominicana*"]
},
{
name: "América Latina",
categories: [ "Belice", "Guyana", "Chile", "Suriname", "Ecuador", "México", "Costa Rica", "Uruguay*", "Perú", "Paraguay", "Nicaragua", "Guatemala", "Bolivia (Estado Plurinacional de)", "Colombia", "América central**", "América del Sur**"]
},
{
name: "Asia central y meridional",
categories: ["Pakistán", "Uzbekistán*", "Nepal*"]
},
{
name: "Asia oriental y sudoriental",
categories: ["Myanmar", "Tailandia*", "Mongolia", "Viet Nam", "Camboya^",]
},
{
name: "Asia occidental",
categories: ["Líbano*", "Palestina*", "Yemen*", "Qatar*", "Jordania*", "Turquía", "Azerbaiyán*", "Armenia* ^", "Georgia* ^", "Asia occidental"]
},
{
name: "África subsahariana",
categories: ["Djibouti", "Mauritania*", "Sierra Leona", "Ghana", "Senegal*", "Níger", "Madagascar", "Zimbabwe", "Malí", "Malawi", "República Centroafricana", "Côte d’Ivoire", "Chad", "Togo", "Liberia", "Namibia", "Uganda", "República Unida de Tanzanía", "Kenya", "Benin", "Etiopía^", "Rwanda^", "Burkina Faso"]
},
{
name: "",
categories: ["África occidental**"]
},
{
name: "Europa",
categories: ["Bosnia y Herzegovina*", "Belarús*", "Moldova, República de*", "Suiza*", "Alemania*", "Eslovaquia*", "Macedonia del Norte*", "Montenegro*", "Italia", "Suecia* ^", "Serbia*", "Portugal", "Hungría* ^", "Lituania* ^"]
},
{
name: "",
categories: ["Países en desarrollo sin litoral"]
},
],
lineColor: "#d7d7d7",
tickColor: "#d7d7d7",
tickLength: 25,
}],
yAxis: [{
labels: {
  style: {
		 fontWeight: 'normal',
		 color: '#999999',
		 fontSize: '11px'
	 },
	},
	min: 0,
	max: 6,
	tickInterval: 1,	
format: '{value}%',
gridLineWidth: 1,
floor: 0,

title: {
  text: '',
  style: {
		color: Highcharts.getOptions().colors[1]
	}
}
}],
tooltip: {
shared: true,
useHTML: true,
hideDelay: 500,
backgroundColor: null,
borderWidth: 0,
shadow: false,
valueSuffix: '%',
style: {
  padding: 0
}
},
legend: {
enabled: false,
},

series: [{
name: '',
color: '#5b9bd5',
data: [
1,
2,
3,
1,
2,
2,
2,
3,
3,
3,
4,
5,
5,
5,
5,
5,
6,
3,
4,
2,
3,
4,
1,
4,
4,
4,
6,
1,
1,
1,
1,
1,
3,
3,
3,
5,
2,
1,
1,
1,
1,
2,
2,
2,
3,
3,
3,
3,
3,
4,
4,
4,
5,
5,
5,
5,
5,
6,
6,
6,
3,
3,
3,
3,
3,
4,
4,
4,
4,
4,
5,
5,
5,
5,
5,
4,
]
}]
}
